<template>
  <panel v-if="page" class="panel-header">
    <div class="header">
      <div>
        <div class="page-info">
          <!-- <div v-if="page.back" class="back">
            <router-link :to="page.back">
              <i class="el-icon-back" /> Back
            </router-link>

            <el-divider direction="vertical" class="divider" />
          </div> -->
          <h1>{{ page.title }}</h1>
        </div>

        <el-breadcrumb
          v-if="page.breadcrumbs && !!page.breadcrumbs.length"
          separator="/" class="breadcumbs">
          <el-breadcrumb-item
            v-for="(breadcrumb, index) in page.breadcrumbs"
            :key="index"
            :to="breadcrumb.to || null">{{ breadcrumb.text }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="actions">
        <el-button
          v-if="showZrebButton"
          type="primary"
          @click="handleZrebClick"
        >
          {{ $tc('tournament.bracket') }}
        </el-button>

        <!-- Generate Bracket Action -->
        <el-button
          v-if="generateBracketAction"
          type="primary"
          :loading="generateBracketAction.generating"
          @click="generateBracketAction.onGenerate"
        >
          {{ $tc('tournament.generate_draw') }}
        </el-button>

        <!-- Bracket Actions -->
        <template v-if="bracketActions">
          <div v-if="bracketActions.notice" class="bracket-notice">
            <i class="el-icon-info"></i>
            <span>{{ bracketActions.notice }}</span>
          </div>
          <div class="bracket-actions">
            <el-button
              v-if="bracketActions.showGenerateMissing"
              type="primary"
              plain
              :loading="bracketActions.generatingMissing"
              @click="bracketActions.onGenerateMissing"
              class="mr-10"
            >
              {{ $tc('tournament.generate_missing_draws') }}
            </el-button>
            <el-button
              v-if="bracketActions.showReset"
              type="danger"
              :loading="bracketActions.resetting"
              @click="bracketActions.onReset"
              class="mr-10"
            >
              {{ $tc('tournament.reset_brackets') }}
            </el-button>
            <el-tooltip
              v-if="bracketActions.showLock"
              :content="bracketActions.isLocked ? 'Otključaj žreb' : 'Zaključaj žreb'"
              placement="top"
            >
              <el-button
                :type="bracketActions.isLocked ? 'warning' : 'primary'"
                :icon="bracketActions.isLocked ? 'el-icon-unlock' : 'el-icon-lock'"
                :loading="bracketActions.locking || bracketActions.unlocking"
                @click="bracketActions.onLock"
                class="mr-10 bracket-actions__lock-icon"
                circle
              />
            </el-tooltip>
            <el-tooltip
              v-if="bracketActions.showPrint"
              content="Štampaj žrebove ili plasmane"
              placement="top"
            >
              <el-button
                icon="el-icon-printer"
                @click="bracketActions.onPrint"
                class="mr-10 bracket-actions__print-icon"
                circle
              />
            </el-tooltip>
          </div>
        </template>

        <v-teleport-location name="header" class="center" />
      </div>
    </div>
  </panel>
</template>

<script>

export default {
  computed: {
    page () {
      return this.$store.state.app.page
    },

    back () {
      return this.page?.back ? this.goBack : () => {}
    },

    showZrebButton () {
      return this.page?.showZrebButton === true
    },

    zrebButtonRoute () {
      return this.page?.zrebButtonRoute || null
    },

    bracketActions () {
      return this.page?.bracketActions || null
    },

    generateBracketAction () {
      return this.page?.generateBracketAction || null
    }
  },

  methods: {
    goBack () {
      this.$router.push(this.page?.back)
    },

    handleZrebClick () {
      if (this.zrebButtonRoute) {
        this.$router.push(this.zrebButtonRoute)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .panel-header {
    margin-bottom: 30px;
    .header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .page-info {
        .back {
          display: inline-block;
          vertical-align: middle;
        }
        h1 {
          display: inline-block;
          vertical-align: middle;
          font-size: 18px;
          margin: 0;
          line-height: 1.5;
        }
        .divider {
          margin: 0 133px;;
        }
      }
    }

    .breadcumbs {
      margin-top: 10px;
    }

    .actions {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      gap: 15px;
      flex-wrap: wrap;
    }

    .bracket-notice {
      display: flex;
      align-items: center;
      gap: 8px;
      color: #409eff;
      font-size: 14px;

      i {
        font-size: 16px;
      }
    }

    .bracket-actions {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    // Unified button styling - pill-shaped design system
    ::v-deep .bracket-actions .el-button {
      height: 40px;
      border-radius: 20px;
      width: 180px;
      padding: 0 20px;
      line-height: 38px;
      font-size: 14px;
      font-weight: 500;
      border: none;
      transition: all 0.3s ease;

      // Icon spacing
      i {
        margin-right: 6px;
        font-size: 16px;
      }

      // Primary/Lock button styling
      &.el-button--primary {
        background-color: #3C485A;
        color: #fff;

        &:hover {
          background-color: #2d3542;
        }

        &:active {
          background-color: #1f252d;
        }

        &:focus {
          outline: 2px solid #409eff;
          outline-offset: 2px;
        }
      }

      // Danger/Reset button styling
      &.el-button--danger {
        background-color: #F56C6C;
        color: #fff;

        &:hover {
          background-color: #f45151;
        }

        &:active {
          background-color: #e63c3c;
        }

        &:focus {
          outline: 2px solid #F56C6C;
          outline-offset: 2px;
        }
      }

      // Warning/Unlock button styling
      &.el-button--warning {
        background-color: #E6A23C;
        color: #fff;

        &:hover {
          background-color: #d8921f;
        }

        &:active {
          background-color: #c47f0e;
        }

        &:focus {
          outline: 2px solid #E6A23C;
          outline-offset: 2px;
        }
      }

      // Default/Print button styling
      &.el-button--default {
        background-color: #fff;
        color: #606266;
        border: 1px solid #dcdfe6;

        &:hover {
          background-color: #f5f7fa;
          border-color: #c0c4cc;
        }

        &:active {
          background-color: #ecf5ff;
          border-color: #b3d8ff;
        }

        &:focus {
          outline: 2px solid #409eff;
          outline-offset: 2px;
        }
      }

      // Disabled state
      &.is-disabled,
      &.is-disabled:hover {
        background-color: #f5f7fa;
        color: #c0c4cc;
        border-color: #e4e7ed;
        cursor: not-allowed;
      }
    }

    // Žreb button styling
    ::v-deep .actions > .el-button--primary {
      height: 40px;
      border-radius: 20px;
      padding: 0 20px;
      font-size: 14px;
      font-weight: 500;
      background-color: #3C485A;
      border: none;
      transition: all 0.3s ease;

      &:hover {
        background-color: #2d3542;
      }

      &:active {
        background-color: #1f252d;
      }

      &:focus {
        outline: 2px solid #409eff;
        outline-offset: 2px;
      }
    }

    ::v-deep .bracket-actions .el-button.bracket-actions__print-icon {
      width: 44px;
      min-width: 44px;
      height: 44px;
      padding: 0;
      border: 1px solid #dcdfe6;
      border-radius: 50%;
      background: #fff;
      color: #606266;
      line-height: 1;

      i {
        margin-right: 0;
        font-size: 18px;
      }

      &:hover {
        background: #f5f7fa;
        border-color: #c0c4cc;
      }

      &:active {
        background: #ecf5ff;
        border-color: #409eff;
      }
    }

    ::v-deep .bracket-actions .el-button.bracket-actions__lock-icon {
      width: 44px;
      min-width: 44px;
      height: 44px;
      padding: 0;
      border-radius: 50%;
      line-height: 1;

      i {
        margin-right: 0;
        font-size: 18px;
      }
    }
  }
  @media (max-width: 768px) {
    .panel-header {
      margin-bottom: 20px;
      .header {
        flex-direction: column;
        align-items: flex-start;
      }
      .actions {
        margin-top: 20px;
      }
    }
  }
</style>
